import React from 'react';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/solid';

const SearchBar = ({ 
  showFilterOptions, 
  setShowFilterOptions, 
  hasActiveFilters, 
  filters, 
  updateSearchText 
}) => {
  return (
    <div className="mb-2 flex items-center gap-2">
      {/* Filter toggle button */}
      <button
        type="button"
        onClick={() => setShowFilterOptions(!showFilterOptions)}
        className={`inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${
          hasActiveFilters 
            ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-200' 
            : 'bg-white text-gray-700 border border-gray-300 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600'
        } hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500`}
      >
        <AdjustmentsHorizontalIcon className="h-4 w-4 mr-1.5" aria-hidden="true" />
        Filters
        {hasActiveFilters && (
          <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-indigo-200 text-indigo-800 dark:bg-indigo-800 dark:text-indigo-200">
            {Object.values(filters).flat().filter(Boolean).length}
          </span>
        )}
      </button>
      
      {/* Search input */}
      <div className="relative flex-grow">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
          </svg>
        </div>
        <input
          type="text"
          name="global-search"
          id="global-search"
          value={filters.searchText}
          onChange={updateSearchText}
          className="block w-full rounded-md border-0 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 py-1.5 pl-10 pr-3 text-gray-900 dark:text-white dark:bg-gray-700 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm leading-6"
          placeholder="Search budget items by scope or subcontractor..."
        />
      </div>
    </div>
  );
};

export default SearchBar;